// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_fe","advertDetailParameterList__header":"c-o_ff","advertDetailParameterList__list":"c-o_fg"};